import "focus-visible";
import { gsap } from "gsap";
//import FontFaceObserver from "fontfaceobserver";
import "./transitions/index.js";
import "./animations/index.js";
import "./helpers/viewport-height.js";
//import "./components/color-schema-selector.js";
import "./components/main-header.js";
import "./components/image-split-view.js";
import { backTop } from "./components/back-to-top.js";
import { svgMap } from "./components/svg-map.js";
import { svgMapDirectory } from "./components/map-svg-directory.js";
import { svgIonDirectory } from "./components/ion-svg-directory.js";
import "./components/list-box.js";
import "./components/forms.js";
import map from "./helpers/map.js";
import "./components/slider.js";
import "./components/collapsible.js";
import "./components/collapsible-links.js";
import "./components/dialog.js";
import cookiesBanner from "./components/cookies-banner.js";
import goBack from "./helpers/go-back.js";
import "./components/share-social.js";
import fullHero from "./components/hero-video.js";
import customVimeo from "./components/custom-vimeo.js";
// import "./components/clock";
import "./components/show-search.js";
import "./components/search.js";
//import "./components/show-search";
import "./helpers/input-masks.js";

cookiesBanner();

backTop(gsap);
if (document.querySelector(".map-svg")) {
    svgMap(gsap);
}

if (document.querySelector(".full-video")) {
    document.querySelectorAll(".has-video").forEach((el) => {
        fullHero(el);
    });
}

if (document.querySelector(".section-video")) {
    document.querySelectorAll(".section-video").forEach((el) => {
        customVimeo(el);
    });
}

if (document.querySelector(".video-post")) {
    document.querySelectorAll(".video-post").forEach((el) => {
        customVimeo(el);
    });
}

if (document.querySelector(".district-directory-section")) {
    document.querySelectorAll(".district-directory-section").forEach((el) => {
        svgMapDirectory(el, gsap);
    });
}

if (document.querySelector(".ion-directory-section")) {
    document.querySelectorAll(".ion-directory-section").forEach((el) => {
        svgIonDirectory(el);
    });
}

if (document.getElementById("map")) {
    map();
}

goBack();
